"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomNode;
(function (CustomNode) {
    CustomNode["ConsoleOutputDisableExpressionNode"] = "ConsoleOutputDisableExpressionNode";
    CustomNode["DebugProtectionFunctionCallNode"] = "DebugProtectionFunctionCallNode";
    CustomNode["DebugProtectionFunctionIntervalNode"] = "DebugProtectionFunctionIntervalNode";
    CustomNode["DebugProtectionFunctionNode"] = "DebugProtectionFunctionNode";
    CustomNode["DomainLockNode"] = "DomainLockNode";
    CustomNode["NodeCallsControllerFunctionNode"] = "NodeCallsControllerFunctionNode";
    CustomNode["SelfDefendingUnicodeNode"] = "SelfDefendingUnicodeNode";
    CustomNode["StringArrayCallsWrapper"] = "StringArrayCallsWrapper";
    CustomNode["StringArrayNode"] = "StringArrayNode";
    CustomNode["StringArrayRotateFunctionNode"] = "StringArrayRotateFunctionNode";
})(CustomNode = exports.CustomNode || (exports.CustomNode = {}));
